import { personasConstants } from './constants';
import { authConstants } from '../auth/constants';

import { studentsConstants } from '../students/constants';


var viewActions = require ('../../store/view.actions');


var personasService = require ('./api');

export const personasActions = {
    updatePersona, getPersona, createPersona, 
    updateRelative, getRelatives,
    removeProfileImage, setCurrentProfileImage,

    deleteRelatedRelation, addRelatedRelation
 }; 


 function  createPersona ( token, data ) {
  return dispatch => {
    dispatch(viewActions.isLoadingModule('savingPersonaDataCard',true)) ;
    personasService.createPersona ( token, data )
    .then( json => {
        if (json.status==='error' && json.code === "DOC_DUPLICATED") {
          dispatch(viewActions.isLoadingModule('savingPersonaDataCard',false)) ;
          viewActions.notification({message:'El documento ingresado ya existe. No se pueden grabar los cambios.',
                                      title:'Atención',type:'danger'});
          return json ;
          } else {
            viewActions.notification({message:'Los cambios fueron grabados con exito.'});
            dispatch(dispatchUpdateStudent( json ));
            dispatch(viewActions.isLoadingModule('savingPersonaDataCard',false));
            dispatch(viewActions.isLoadingModule('editingPersonaDataCard',false))
        }
    } )
}
}

function  updatePersona ( token, personaID , data, isMyProfile ) {
  return dispatch => {
    dispatch(viewActions.isLoadingModule('savingPersonaDataCard',true)) ;
    personasService.updatePersona ( token, personaID , data )
    .then( json => {
        if (json.status==='error' && json.code === "DOC_DUPLICATED") {
          dispatch(viewActions.isLoadingModule('savingPersonaDataCard',false)) ;
          viewActions.notification({message:'El documento ingresado ya existe. No se pueden grabar los cambios.',
                                      title:'Atención',type:'danger'});
          } else {
          if (isMyProfile) {
                dispatch(dispatchUpdateMyProfile(json));
          } 
            else  {
              dispatch(dispatchUpdateStudent( json ));
            }
          viewActions.notification({message:'Los cambios fueron grabados con exito.'});
          dispatch(viewActions.isLoadingModule('savingPersonaDataCard',false));
          dispatch(viewActions.isLoadingModule('editingPersonaDataCard',false))
        }
    } )
}
}

function  updateRelative ( token, personaID , data, isMyProfile ) {
  return dispatch => {
    dispatch(viewActions.isLoadingModule('savingRelativeDataCard',true)) ;
    personasService.updatePersona ( token, personaID , data )
    .then( json => {
      if (json.status==='error' && json.code === "DOC_DUPLICATED") {
        dispatch(viewActions.isLoadingModule('savingRelativeDataCard',false)) ;
        viewActions.notification({message:'El documento ingresado ya existe. No se pueden grabar los cambios.',
                    title:'Atención',type:'danger'});
        } 
      else {
        if (isMyProfile) {
          dispatch( dispatchRefreshMyRelatives( personaID, json ) );
        } 
          else dispatch(dispatchRefreshRelative(personaID, json ))
        dispatch(viewActions.isLoadingModule('savingRelativeDataCard',false));
        dispatch(viewActions.isLoadingModule('editingRelativeDataCard',false))
        }
        viewActions.notification({message:'Los cambios fueron grabados con exito.'});

    } )
  }
}

function getPersona( token, personaID  ) { 
  return dispatch => {
         
          dispatch(viewActions.isLoadingModule('getPersona',true)) ;
          personasService.getPersona( token, personaID )
          .then( json => {
            
              if (json.birthdate) json.birthdate = json.birthdate.replace('Z','')
              dispatch( { 
                          type: personasConstants.SHOW_PERSONA,
                          persona: json
                        })
              dispatch(viewActions.isLoadingModule('getPersona',false) )
          } )
          
  }
}


function addRelatedRelation( token, studentID, relatedID, relationType, isMyProfile, rel ) { 
  return dispatch => {
         
          personasService.addRelatedRelation( token, studentID, relatedID, relationType  )
          .then( json => {
              dispatch( { 
                type: (isMyProfile?personasConstants.ADD_RELATED:studentsConstants.STUDENT_ADD_RELATED) , 
                related: { ...rel , relation_type: relationType, is_tutor:"1" }
              })
              
              viewActions.notification({message:'Se agrego correctamente al familiar',
              title:'',type:'success'});
          
          
          } )
          
  }
}

function deleteRelatedRelation( token, studentID, relatedID, isMyProfile   ) { 
  return dispatch => {
         
          // dispatch(viewActions.isLoadingModule('getRelatives',true)) ;
          
          personasService.deleteRelatedRelation( token, studentID, relatedID  )
          .then( json => {
              dispatch( { 
                type: (isMyProfile?personasConstants.REMOVE_RELATED:studentsConstants.STUDENT_REMOVE_RELATED) , 
                related_id: relatedID
              })
              
              viewActions.notification({message:'Se eliminó correctamente al familiar',
              title:'',type:'success'});
          
          
          } )
          
  }
}

function getRelatives( token, studentID  ) { 
    return dispatch => {
           
            dispatch(viewActions.isLoadingModule('getRelatives',true)) ;
            personasService.getRelatives( token, studentID )
            .then( json => {
                dispatch(dispatchShowRelatives( json ))
                dispatch(viewActions.isLoadingModule('getRelatives',false) )
            } )
            
    }
  }

  function  setCurrentProfileImage ( token, personaID , fileUrl ) {
    let data = { image: fileUrl }
    return dispatch => {
      personasService.updatePersona ( token, personaID , data )
      .then( json => {
          dispatch(dispatchUpdateStudent( json ))
      } )
    }
  }
  

  /// ACA
  function  removeProfileImage ( token, personaID , id ) {
    return dispatch => {
      personasService.removeProfileImage ( token, personaID , id )
      .then( json => {
          dispatch( dispatchUpdateProfileImages(json) )
      } )
    }
  }
  




  ////


  function dispatchUpdateProfileImages(json) {
    return { 
      type: personasConstants.UPDATE_IMAGE_PROFILE,
      images: json
    }
  }
  

  
  function dispatchRefreshMyRelatives(relativeID, json) {
    return { 
      type: personasConstants.UPDATE_MY_RELATIVES,
      relativeID: relativeID ,
      relative: json
    }
  }  

function dispatchRefreshRelative(relativeID, json) {
    return { 
      type: personasConstants.UPDATE_RELATIVE,
      relativeID: relativeID ,
      relative: json
    }
  }  
  
function dispatchShowRelatives(json) {
    return { 
      type: personasConstants.SHOW_RELATIVES,
      relatives: json
    }
  }
 
  function dispatchUpdateMyProfile(json) {
    return { 
      type:  authConstants.UPDATE_USER_PROFILE,
      userUpdate: json
    }
  }
  
  
  // function dispatchUpdatePersona(json) {
  //   return { 
  //     type: personasConstants.UPDATE_PERSONA,
  //     personaUpdate: json
  //   }
  // }
  
  function dispatchUpdateStudent(json) {
    return { 
      type: studentsConstants.UPDATE_STUDENT, 
      studentUpdate: json
    }
  }
  